(() => {
  angular.module('app').component('clinicPatientTicketReferralLetter', {
    templateUrl: require('./widget.html'),
    controller: ClinicPatientTicketReferralLetterController,
    controllerAs: 'vm',
    bindings: {
      patient: '<',
      doctor: '<',
      ticket: '<',
      currencyCode: '<',
      isApplyTax: '<',
    }
  });

  function ClinicPatientTicketReferralLetterController() {
    const vm = this;

    vm.$onChanges = onChanges;
    vm.clearReferralDetails = clearReferralDetails;
    vm.calculateSst6 = calculateSst6;

    function onChanges(changes) {
      if (changes.ticket && changes.ticket.currentValue) {
        vm.needReferral = !!vm.ticket.referralLetter;
      }
    };

    function clearReferralDetails() {
      vm.ticket.referralLetter = null;
    };

    function calculateSst6() {
      const taxRate = ((vm.ticket.taxPercentage || 0) / 100) + 1;

      if (!vm.ticket.referralLetter) {
        vm.ticket.referralLetter = vm.ticket.referralLetter || {};
        vm.ticket.referralLetter.amount = vm.ticket.referralLetter.amount || 0;
      }

      const grossAmount = App.evenRound(vm.ticket.referralLetter.amount/taxRate, 2);
      const taxAmount = App.evenRound(vm.ticket.referralLetter.amount - grossAmount, 2);

      return {
        grossAmount,
        taxAmount,
      };
    }
  }
})();
